const wasteData = {
  Assets: [
    {
      Id: 3001,
      Enabled: true,
      AssetType: "PaperGarbage",
      Code: "R001",
      ProviderId: 14,
      Latitude: 51.9505,
      Longitude: 4.0557,
      HasCondition: false,
      HasConditionEnum: "NoCondition",
    },
    {
      Id: 3002,
      Enabled: true,
      AssetType: "GlassGarbage",
      Code: "R002",
      ProviderId: 14,
      Latitude: 51.9498,
      Longitude: 4.0593,
      HasCondition: false,
      HasConditionEnum: "NoCondition",
    },
    {
      Id: 3003,
      Enabled: true,
      AssetType: "PaperGarbage",
      Code: "A001",
      ProviderId: 14,
      Latitude: 52.4007,
      Longitude: 4.8942, // Amsterdam port terminal
      HasCondition: false,
      HasConditionEnum: "NoCondition",
    },
    {
      Id: 3004,
      Enabled: true,
      AssetType: "GlassGarbage",
      Code: "A002",
      ProviderId: 14,
      Latitude: 52.4006,
      Longitude: 4.8950,
      HasCondition: false,
      HasConditionEnum: "NoCondition",
    },
    {
      Id: 3005,
      Enabled: true,
      AssetType: "PaperGarbage",
      Code: "G001",
      ProviderId: 14,
      Latitude: 51.057,
      Longitude: 3.7176,
      HasCondition: false,
      HasConditionEnum: "NoCondition",
    },
    {
      Id: 3006,
      Enabled: true,
      AssetType: "GlassGarbage",
      Code: "G002",
      ProviderId: 14,
      Latitude: 51.0554,
      Longitude: 3.7199,
      HasCondition: false,
      HasConditionEnum: "NoCondition",
    },
    {
      Id: 3007,
      Enabled: true,
      AssetType: "PaperGarbage",
      Code: "AN001",
      ProviderId: 14,
      Latitude: 51.2312,
      Longitude: 4.4018,
      HasCondition: false,
      HasConditionEnum: "NoCondition",
    },
    {
      Id: 3008,
      Enabled: true,
      AssetType: "GlassGarbage",
      Code: "AN002",
      ProviderId: 14,
      Latitude: 51.2305,
      Longitude: 4.4031,
      HasCondition: false,
      HasConditionEnum: "NoCondition",
    },
    {
      Id: 3009,
      Enabled: true,
      AssetType: "PaperGarbage",
      Code: "AN003",
      ProviderId: 14,
      Latitude: 51.2289,
      Longitude: 4.4055,
      HasCondition: false,
      HasConditionEnum: "NoCondition",
    },
    {
      Id: 3010,
      Enabled: true,
      AssetType: "GlassGarbage",
      Code: "AN004",
      ProviderId: 14,
      Latitude: 51.2290,
      Longitude: 4.4053,
      HasCondition: false,
      HasConditionEnum: "NoCondition",
    },
    {
      Id: 870,
      Enabled: true,
      AssetType: "PaperGarbage",
      Code: "6001",
      ProviderId: 14,
      Latitude: 51.084366,
      Longitude: 3.754029,
      HasCondition: false,
      HasConditionEnum: "NoCondition",
    },
    {
      Id: 871,
      Enabled: true,
      AssetType: "GlassGarbage",
      Code: "6002",
      ProviderId: 14,
      Latitude: 51.084374,
      Longitude: 3.753903,
      HasCondition: false,
      HasConditionEnum: "NoCondition",
    },
    {
    "Id": 9000,
    "Enabled": true,
    "AssetType": "PaperGarbage",
    "Code": "W001",
    "ProviderId": 14,
    "Latitude": 51.085391,
    "Longitude": 3.753805,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9001,
    "Enabled": true,
    "AssetType": "GlassGarbage",
    "Code": "N002",
    "ProviderId": 14,
    "Latitude": 51.234344,
    "Longitude": 4.401538,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9002,
    "Enabled": true,
    "AssetType": "PaperGarbage",
    "Code": "W003",
    "ProviderId": 14,
    "Latitude": 52.398966,
    "Longitude": 4.895051,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9003,
    "Enabled": true,
    "AssetType": "GlassGarbage",
    "Code": "H004",
    "ProviderId": 14,
    "Latitude": 51.237105,
    "Longitude": 4.401818,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9004,
    "Enabled": true,
    "AssetType": "PaperGarbage",
    "Code": "M005",
    "ProviderId": 14,
    "Latitude": 51.238313,
    "Longitude": 4.399691,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9005,
    "Enabled": true,
    "AssetType": "GlassGarbage",
    "Code": "Z006",
    "ProviderId": 14,
    "Latitude": 51.06079,
    "Longitude": 3.722586,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9006,
    "Enabled": true,
    "AssetType": "PaperGarbage",
    "Code": "Z007",
    "ProviderId": 14,
    "Latitude": 52.402771,
    "Longitude": 4.895149,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9007,
    "Enabled": true,
    "AssetType": "GlassGarbage",
    "Code": "Z008",
    "ProviderId": 14,
    "Latitude": 52.398948,
    "Longitude": 4.885944,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9008,
    "Enabled": true,
    "AssetType": "PaperGarbage",
    "Code": "H009",
    "ProviderId": 14,
    "Latitude": 51.956586,
    "Longitude": 4.057363,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9009,
    "Enabled": true,
    "AssetType": "GlassGarbage",
    "Code": "N010",
    "ProviderId": 14,
    "Latitude": 51.057316,
    "Longitude": 3.711405,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9010,
    "Enabled": true,
    "AssetType": "PaperGarbage",
    "Code": "W011",
    "ProviderId": 14,
    "Latitude": 51.061617,
    "Longitude": 3.723773,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9011,
    "Enabled": true,
    "AssetType": "GlassGarbage",
    "Code": "H012",
    "ProviderId": 14,
    "Latitude": 51.229269,
    "Longitude": 4.402099,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9012,
    "Enabled": true,
    "AssetType": "PaperGarbage",
    "Code": "W001",
    "ProviderId": 14,
    "Latitude": 51.946239,
    "Longitude": 4.052734,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9013,
    "Enabled": true,
    "AssetType": "GlassGarbage",
    "Code": "S002",
    "ProviderId": 14,
    "Latitude": 52.395442,
    "Longitude": 4.901449,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9014,
    "Enabled": true,
    "AssetType": "PaperGarbage",
    "Code": "N003",
    "ProviderId": 14,
    "Latitude": 52.396332,
    "Longitude": 4.903969,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9015,
    "Enabled": true,
    "AssetType": "GlassGarbage",
    "Code": "H004",
    "ProviderId": 14,
    "Latitude": 52.393621,
    "Longitude": 4.901325,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9016,
    "Enabled": true,
    "AssetType": "PaperGarbage",
    "Code": "H005",
    "ProviderId": 14,
    "Latitude": 52.399823,
    "Longitude": 4.891040,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9017,
    "Enabled": true,
    "AssetType": "GlassGarbage",
    "Code": "W006",
    "ProviderId": 14,
    "Latitude": 52.398214,
    "Longitude": 4.885383,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9018,
    "Enabled": true,
    "AssetType": "PaperGarbage",
    "Code": "M007",
    "ProviderId": 14,
    "Latitude": 51.231532,
    "Longitude": 4.407472,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9019,
    "Enabled": true,
    "AssetType": "GlassGarbage",
    "Code": "S008",
    "ProviderId": 14,
    "Latitude": 51.061444,
    "Longitude": 3.722962,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9020,
    "Enabled": true,
    "AssetType": "PaperGarbage",
    "Code": "H009",
    "ProviderId": 14,
    "Latitude": 51.228642,
    "Longitude": 4.396648,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9021,
    "Enabled": true,
    "AssetType": "GlassGarbage",
    "Code": "Z010",
    "ProviderId": 14,
    "Latitude": 52.393349,
    "Longitude": 4.892936,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9022,
    "Enabled": true,
    "AssetType": "PaperGarbage",
    "Code": "W011",
    "ProviderId": 14,
    "Latitude": 51.062566,
    "Longitude": 3.722878,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  },
  {
    "Id": 9023,
    "Enabled": true,
    "AssetType": "GlassGarbage",
    "Code": "Z012",
    "ProviderId": 14,
    "Latitude": 52.397712,
    "Longitude": 4.904232,
    "HasCondition": false,
    "HasConditionEnum": "NoCondition"
  }
  ],
};

export default wasteData;
